import cx from 'classnames';
import { css } from 'emotion';
import {
    ButtonBack,
    ButtonNext,
    CarouselProvider,
    DotGroup,
    Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import React, { PureComponent } from 'react';
import { colors, mq } from './../../../../css';
import Arrow from './arrow.svg';
import {
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6,
    Slide7,
} from './slides';

export default class Steps extends PureComponent {
    constructor() {
        super();

        this.state = {
            breakpoint: 0,
        };

        this.resize = this.resize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize.bind(this));
    }

    resize() {
        const w = window.innerWidth;
        if (w < 480) {
            this.setState(() => ({ breakpoint: 0 }));
            return;
        }
        if (w < 768) {
            this.setState(() => ({ breakpoint: 480 }));
            return;
        }
        if (w < 992) {
            this.setState(() => ({ breakpoint: 768 }));
            return;
        }
        if (w < 1200) {
            this.setState(() => ({ breakpoint: 992 }));
            return;
        }
        if (w < 1400) {
            this.setState(() => ({ breakpoint: 1200 }));
            return;
        }
        if (w < 1600) {
            this.setState(() => ({ breakpoint: 1400 }));
            return;
        }
        if (w < 3000) {
            this.setState(() => ({ breakpoint: 1600 }));
            return;
        }
    }

    getSlideHeight() {
        const { breakpoint } = this.state;
        switch (breakpoint) {
            case 0:
                return 150;
            case 480:
                return 150;
            case 768:
                return 100;
            case 992:
                return 140;
            case 1200:
                return 130;
            case 1400:
                return 120;
            case 1600:
                return 102;
        }
    }

    render() {
        return (
            <CarouselProvider
                className={s.wrapper}
                naturalSlideWidth={100}
                naturalSlideHeight={this.getSlideHeight()}
                totalSlides={7}>
                <ButtonBack className={s.button}>
                    <Arrow />
                </ButtonBack>

                <Slider className={s.sliderWrapper}>
                    <Slide1 index={0} />
                    <Slide2 index={1} />
                    <Slide3 index={2} />
                    <Slide4 index={3} />
                    <Slide5 index={4} />
                    <Slide6 index={5} />
                    <Slide7 index={6} />
                </Slider>

                <ButtonNext className={cx(s.button, s.buttonNext)}>
                    <Arrow />
                </ButtonNext>

                <DotGroup className={s.dotGroup} />
            </CarouselProvider>
        );
    }
}

const s = {};

s.wrapper = css`
    position: relative;
    width: 100%;
    height: 100%;
`;

s.sliderWrapper = css`
    margin-bottom: 10px;
    ${mq({
        marginLeft: [20, 60, 80],
        marginRight: [20, 60, 80],
    })};
`;

s.button = css`
    position: absolute;
    transform: translateY(-50%);
    background: none;
    border: none;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    outline: none;
    svg {
        width: 100%;
        height: 100%;
    }
    &[disabled] {
        opacity: 0.2;
    }
    z-index: 22;
    ${mq({
        left: [0, 20, 40],
        top: ['30%', '50%'],
    })};
`;

s.buttonNext = css`
    transform: translateY(-50%) rotate(180deg);
    left: auto;
    ${mq({
        right: [0, 20, 40],
    })};
`;

s.dotGroup = css`
    position: relative;
    width: 100%;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    ${mq({
        marginBottom: [40, 40, 80],
    })};
    button {
        background: none;
        border: 1px solid ${colors.blue};
        border-radius: 100%;
        height: 15px;
        width: 15px;
        padding: 0;
        margin: 0 4px;
        &.carousel__dot--selected {
            background: ${colors.blue};
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/steps.component.js